import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationComponent} from './notification.component';
import {MessagesService} from '../../services/messages.service';
import {MessagesModule} from 'primeng/primeng';


@NgModule({
  declarations: [NotificationComponent],
  imports: [
    CommonModule,
    MessagesModule
  ],
  exports: [
    NotificationComponent
  ],
  providers: [
    MessagesService
  ]
})
export class NotificationModule {
}
